import { AirdropClaimBanner } from './AirdropClaimBanner';

export default AirdropClaimBanner;
